export const QUESTION = 'Have you faced any of these feelings?'

export const OPTION_VALUES = {
  LACK_OF_ENERGY: 'lack_of_energy',
  LITTLE_INTEREST: 'little_interest',
  TROUBLE_WITH_CONCENTRATION: 'trouble_with_concentration',
  INCREASED_IRRITABILITY: 'increased_irritability',
}
